import React from "react";
import { ContainerOutlined, ShoppingOutlined, PlusSquareOutlined } from "@ant-design/icons";

function ServiceGlyph({ category }) {
  const cls = "hr-fp-service-row__glyph";
  if (category === "baggage") {
    return <ContainerOutlined className={cls} aria-hidden />;
  }
  if (category === "trolley") {
    return <ShoppingOutlined className={cls} aria-hidden />;
  }
  return <PlusSquareOutlined className={cls} aria-hidden />;
}

export default function AncillaryRow({ category, titleHe, description, assignee, fare, currency }) {
  const fareStr =
    fare != null && Number.isFinite(Number(fare))
      ? `${Number(fare)}${currency ? ` ${currency}` : ""}`
      : null;

  return (
    <div className="hr-fp-service-row">
      <span className="hr-fp-service-row__icon-wrap" aria-hidden>
        <ServiceGlyph category={category} />
      </span>
      <div className="hr-fp-service-row__body">
        <div className="hr-order-secondary hr-fp-service-row__title">{titleHe}</div>
        <div className="hr-order-tertiary hr-fp-service-row__desc">{description}</div>
        <div className="hr-order-tertiary hr-fp-service-row__assignee">{assignee}</div>
      </div>
      {fareStr ? (
        <div className="hr-order-secondary hr-fp-service-row__fare" translate="no">
          {fareStr}
        </div>
      ) : null}
    </div>
  );
}
